import {
  MutationCache,
  QueryCache,
  QueryClient,
} from "@tanstack/react-query"

import {
  handleMutationError,
  handleQueryError,
} from "@/lib/auth/session-expiry"

/**
 * The app's ``QueryClient``. The cache ``onError`` callbacks see every failed
 * call, so the logout-on-401 handling lives there (design §1.2): a query 401
 * hard-redirects to ``/signin``, a mutation 401 raises the soft re-auth prompt.
 */
export function makeQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({ onError: handleQueryError }),
    mutationCache: new MutationCache({
      // ``meta`` lets a mutation opt out (e.g. the deliberate Sign out).
      onError: (error, _variables, _context, mutation) =>
        handleMutationError(error, mutation.meta),
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  })
}
